import PropTypes from 'prop-types'

export const WaterTurnsRestrictionShape = PropTypes.shape({
    id: PropTypes.number,
    level: PropTypes.number,
    label: PropTypes.string,
    description: PropTypes.string,
    comment: PropTypes.string,
    color: PropTypes.string,
    entryFrequency: PropTypes.number,
    entryFrequencyDay: PropTypes.number,
    entryRangeDaysBefore: PropTypes.number,
    entryRangeDaysAfter: PropTypes.number,
    percentRestriction: PropTypes.number,
})